import RestResource from '../rest.service';
import Service from '../api.service';

export default class ProjectionsStatisticsService extends RestResource {
  varietyTotals(params) {
    return Service.get(`${this.resource}/varieties`, { params: params }).catch(this.handleErrors);
  }

  distributorTotals(params) {
    return Service.get(`${this.resource}/distributors`, { params: params }).catch(this.handleErrors);
  }

  cropTotals(params) {
    return Service.get(`${this.resource}/crops`, { params: params }).catch(this.handleErrors);
  }

  getVarietyTotalsPdf(params, filename) {
    return Service.get(`${this.resource}/varieties/pdf`, { params: params, responseType: 'arraybuffer' })
      .then((res) => this.downloadPDF(res, filename))
      .catch(this.handleErrors);
  }
  getCropsTotalsPdf(params, filename) {
    return Service.get(`${this.resource}/crops/pdf`, { params: params, responseType: 'arraybuffer' })
      .then((res) => this.downloadPDF(res, filename))
      .catch(this.handleErrors);
  }
  getDistributorsTotalsPdf(params, filename) {
    return Service.get(`${this.resource}/distributors/pdf`, { params: params, responseType: 'arraybuffer' })
      .then((res) => this.downloadPDF(res, filename))
      .catch(this.handleErrors);
  }

  constructor() {
    super('stats/projections');
  }
}
